export const dropdownSalesInitialData = [
  { value: 'non-free', name: 'Sales Berbayar' },
  { value: 'free', name: 'Sales Rp 0' }
]
